import '../../css/mk-brand.css';
import React, {useState, useEffect, } from "react";
import Carousel from "react-simply-carousel";
import mkFrame from "../../media/mk-frame.png";
import RarityPanel from "./rarity-panel";

function OGChefsPanel(props) {
  useEffect(() => {}, );
  const [activeSlide, setActiveSlide] = useState(0);
  const defaultDisplayText = "The creators of metaKitchen will give access to the mK earning ecosystem and grant you a role in the mKSyndicate. OG’s will be used for staking and earning $CHEF rewards, unlocking a variety of features within the mK platform.";
  const stakingDisplayText = "OG Chef can be staked for $CHEF rewards. There will be a 7, 15, 30 Day lockup and your OG Chef star rarity will impact the $CHEF farmed.";
  const syndicateDisplayText = "Be a founder of the mK Syndicate - assume a leadership role and impact: art, investments, community, roadmap, collabs and much more. Funded with 10% of mint revenue and 50% of royalties.   ";
  const giveawayDisplayText = "Participate in our charity giveaway to award 5% of mint to chefs in need in our community.";
  const freeMintDisplayText = "OG Chefs will have the ability to mint free metaChef drops, ingredients and utensil NFT's with their CHEF coin farmed. ";

  const swapDisplay = (text = null) => {
      const swap = (name) => {
          const e = document.getElementById(name);
          if (e) {
              if (text) {
                  e.innerText = text;
              } else {
                  e.innerText = defaultDisplayText;
              }
          }
      }
      swap('mk-display');
      swap('mk-display-md');
  };
  const background = props.background ? 'bg-zinc-800' : '';
  return (
      <div id="og-chefs-panel" className="m-2">
          <div className={`md:hidden flex flex-col container ${background} rounded-lg mx-auto p-2`}>
              <div className="flex-col p-2">
                  <div className="flex">
                      <h1 className="text-4xl leading-6 text-white font-extrabold">
                          OG
                      </h1>
                      <h1 className="text-4xl leading-6 text-brand font-extrabold">
                          Chef
                      </h1>
                  </div>
                  <h4 className="pt-2 leading-6 text-gray-400 text-2xl font-bold">
                      THE FOUNDATION OF METAKITCHEN
                  </h4>
                  <p id="mk-display-md" className="mx-auto h-40 pt-2 leading-6 text-white">
                      The creators of metaKitchen will give access to the mK earning ecosystem and grant you a role in the mKSyndicate.
                      OG’s will be used for staking and earning $CHEF rewards, unlocking a variety of features within the mK platform.
                  </p>
                  <br />
              </div>
              <div className="flex-col p-2">
                  <div className="flex space-x-1">
                      <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                           onMouseEnter={()=>swapDisplay(stakingDisplayText)}
                           onMouseLeave={()=>swapDisplay()}
                      ><span className="align-middle">Staking</span></div>
                      <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                           onMouseEnter={()=>swapDisplay(syndicateDisplayText)}
                           onMouseLeave={()=>swapDisplay()}
                           onClick={()=>swapDisplay(syndicateDisplayText)}
                      >mKSyndicate Founder</div>
                  </div>
                  <div className="p-1" />
                  <div className="flex space-x-1">
                      <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                           onMouseEnter={()=>swapDisplay(giveawayDisplayText)}
                           onMouseLeave={()=>swapDisplay()}
                           onClick={()=>swapDisplay(giveawayDisplayText)}
                      >Chef in Need Giveaway</div>
                      <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                           onMouseEnter={()=>swapDisplay(freeMintDisplayText)}
                           onMouseLeave={()=>swapDisplay()}
                           onClick={()=>swapDisplay(freeMintDisplayText)}
                      >metaChef Free Mint</div>
                  </div>
              </div>
              <div className="h-8" />
              <div className="relative">
                  <div className="z-10 absolute top-0 -mt-16">
                      <img className="" src={mkFrame} />
                  </div>
                  <div className="">
                      <Carousel
                          autoplay
                          delay={500}
                          itemsToShow={1}
                          speed={1000}
                          updateOnItemClick
                          containerProps={{
                              style: {
                                  width: "100%",
                                  justifyContent: "space-between",
                              }
                          }}
                          activeSlideIndex={activeSlide}
                          onRequestChange={setActiveSlide}
                      >
                          {Array.from({ length: 9 }).map((item, index) => (
                              <div className=""
                                   key={index}
                                   style={{
                                       width: 250,
                                       height: 230,
                                       textAlign: "center",
                                       boxSizing: "border-box",
                                       padding: "4px",
                                   }}
                              >
                                  <img className="" src={'/carousel/carousel-' + index + '.png'} />
                              </div>
                          ))}
                      </Carousel>
                  </div>
              </div>
              <RarityPanel />
          </div>
          <div className={`hidden md:block flex mx-auto container rounded-lg md:max-w-6xl ${background}`}>
              <div className="flex pt-4 px-4">
                  <div className="hidden flex-col w-32">&nbsp;</div>
                  <div className="flex-col">
                      <div className="mx-auto p-2">
                          <div className="flex">
                              <h1 className="text-6xl leading-none text-white font-extrabold">
                                  OG
                              </h1>
                              <h1 className="text-6xl leading-none text-brand font-extrabold">
                                  Chef
                              </h1>
                          </div>
                          <h4 className="pt-2 leading-6 text-white text-gray-400 text-2xl font-bold">
                              THE FOUNDATION OF METAKITCHEN
                          </h4>
                          <p id="mk-display" className="mx-auto pt-2 leading-6 text-white h-48 max-w-2xl">The creators of metaKitchen will give access to the mK earning ecosystem and grant you a role in the mKSyndicate.
                              OG’s will be used for staking and earning $CHEF rewards, unlocking a variety of features within the mK platform.
                          </p>
                      </div>
                      <div className="mx-auto p-2">
                          <div className="flex space-x-1">
                              <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                                   onMouseEnter={()=>swapDisplay(stakingDisplayText)}
                                   onMouseLeave={()=>swapDisplay()}
                              >Staking</div>
                              <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                                   onMouseEnter={()=>swapDisplay(syndicateDisplayText)}
                                   onMouseLeave={()=>swapDisplay()}
                                   onClick={()=>swapDisplay(syndicateDisplayText)}
                              >mKSyndicate Founder</div>
                          </div>
                          <div className="p-1" />
                          <div className="flex space-x-1">
                              <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                                   onMouseEnter={()=>swapDisplay(giveawayDisplayText)}
                                   onMouseLeave={()=>swapDisplay()}
                                   onClick={()=>swapDisplay(giveawayDisplayText)}
                              >Chef in Need Giveaway</div>
                              <div className="w-1/2 p-2 rounded-lg text-white font-bold bg-brand text-center cursor-pointer hover:bg-zinc-400 hover:text-black"
                                   onMouseEnter={()=>swapDisplay(freeMintDisplayText)}
                                   onMouseLeave={()=>swapDisplay()}
                                   onClick={()=>swapDisplay(freeMintDisplayText)}
                              >metaChef Free Mint</div>
                          </div>
                      </div>
                  </div>
                  <div className="hidden lg:block flex-col w-14">&nbsp;</div>
                  <div className="flex lg:px-16 md:px-8" style={{margin: 'auto'}}>
                      <div className="lg:hidden relative rounded p-8">
                          <div className="z-10 absolute top-0 -ml-8">
                              <img className="" src={mkFrame} />
                          </div>
                          <Carousel
                              autoplay
                              delay={500}
                              itemsToShow={1}
                              speed={1000}
                              easing={'linear'}
                              updateOnItemClick
                              containerProps={{
                                  style: {
                                      width: "100%",
                                      justifyContent: "space-between",
                                      borderRadius: "5px!important",
                                  }
                              }}
                              activeSlideIndex={activeSlide}
                              onRequestChange={setActiveSlide}
                          >
                              {Array.from({ length: 9 }).map((item, index) => (
                                  <div className="rounded-lg"
                                       key={index}
                                       style={{
                                           width: 250,
                                           height: 250,
                                           textAlign: "center",
                                           lineHeight: "240px",
                                           boxSizing: "border-box",
                                           padding: "4px",
                                       }}
                                  >
                                      <img className="rounded-lg" src={'/carousel/carousel-' + index + '.png'} />
                                  </div>
                              ))}
                          </Carousel>
                      </div>
                      <div className="hidden lg:block relative rounded p-8">
                          <div className="z-10 absolute top-0 -ml-12 -mt-8">
                              <img className="h-full" src={mkFrame} />
                          </div>
                          <Carousel
                              autoplay
                              delay={500}
                              itemsToShow={1}
                              speed={1000}
                              easing={'linear'}
                              updateOnItemClick
                              containerProps={{
                                  style: {
                                      width: "100%",
                                      justifyContent: "space-between",
                                      borderRadius: '5px',
                                  }
                              }}
                              activeSlideIndex={activeSlide}
                              onRequestChange={setActiveSlide}
                          >
                              {Array.from({ length: 9 }).map((item, index) => (
                                  <div className=""
                                       key={index}
                                       style={{
                                           width: 350,
                                           height: 300,
                                           textAlign: "center",
                                           lineHeight: "240px",
                                           boxSizing: "border-box",
                                           padding: "4px",
                                       }}
                                  >
                                      <img className="" src={'/carousel/carousel-' + index + '.png'} />
                                  </div>
                              ))}
                          </Carousel>
                      </div>
                  </div>
              </div>
              <RarityPanel background={props.background} />
          </div>
     </div>
    );
}
export default OGChefsPanel;

